export function getPageTitle<C extends Vike.PageContext>(pageContext?: C): string {
  if (!pageContext) {
    return wrapPageTitle();
  }

  const config =
    // ('title' in pageContext && pageContext.title) ||
    ('data' in pageContext && pageContext.data?.title) ||
    ('config' in pageContext && pageContext.config?.title) ||
    undefined;

  if (typeof config === 'function') {
    return wrapPageTitle(config(pageContext));
  }

  return wrapPageTitle(config);
}

export function wrapPageTitle(title?: string | null | undefined) {
  return `${title || 'Right Angle Sports'} - RAS`;
}
